import type { FC } from "react";
import { MobileStaffing } from "../mobile/MobileStaffing";
import { MobileGapsShell } from "./MobileGapsShell";
import { useIsGapsViewActive } from "./useGapsViewPreference";

/**
 * Which mobile Staffing screen `/:departmentId/staffing/:dateString?` renders — the gaps-first shell or
 * the classic weekly list.
 *
 * The fork lives in a COMPONENT rather than in the route's `access` guard because it depends on a
 * feature flag, and `FeatureFlagsProvider` renders *below* `AppRoutes`: the `element: (ctx) => …`
 * factory runs during `buildRoutes`, outside every app provider, so it may construct a component but
 * never call a hook (`App.tsx` documents the rule; `HiringChatRoute` is the other worked example).
 *
 * Classic keeps its own URL (`staffing/classic/:dateString?`) so it is linkable and survives a
 * department switch — this component only decides what the DEFAULT staffing URL shows.
 */
export const MobileStaffingRouteSwitch: FC = () => {
	// The same answer the bottom bar and the header read — the saved choice, else the rollout flag's — so the screen
	// and the chrome around it can never disagree.
	const isGapsViewActive = useIsGapsViewActive();
	return isGapsViewActive ? <MobileGapsShell /> : <MobileStaffing />;
};
